import { config_settings } from '@/config.js';
import Vue from 'vue';

export const getDeliveryDetailById = (id) => {
  return Vue.$http({
    method: 'get',
    url: config_settings.RESOURCE_SERVER_URL + '/GET/deliverys/' + id,
  });
};

export const getDeliverysByIdAndLocation = (id, idDistrict) => {
  return Vue.$http({
    method: 'get',
    url: config_settings.RESOURCE_SERVER_URL + '/GET/deliverys/' + id + '/district/' + idDistrict,
  });
};

export const getDeliverysOptionsInStore = () => {
  return Vue.$http({
    method: 'get',
    url: config_settings.RESOURCE_SERVER_URL + '/GET/deliverys/atstore',
  });
};

export const getHomeDeliverysOptions = (selectedAddressDistrict, totalValue) => {
  return Vue.$http({
    method: 'get',
    url:
      config_settings.RESOURCE_SERVER_URL +
      '/GET/deliverys/inhouse/district/' +
      selectedAddressDistrict +
      '/ammount/' +
      totalValue,
  });
};

export const getTransportAgencyAddress = (token) => {
  return Vue.$http({
    method: 'get',
    url: config_settings.RESOURCE_SERVER_URL + '/GET/transport-agency-address',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const getTransportAgencyAddressPaginate = (page, crit, token) => {
  return Vue.$http({
    method: 'get',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    url:
      config_settings.RESOURCE_SERVER_URL +
      '/GET/transport-agency-address?xPag=' +
      crit +
      '&&nPag=' +
      page,
  });
};

export const postSearchTransportAgencyAddress = (searchAtributte, token) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.RESOURCE_SERVER_URL + '/POST/search-transport-agency-address',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    data: {
      query: searchAtributte,
    },
  });
};
